module.exports = __webpack_public_path__ + "img/how_to_loan.538745ae.png";